import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideo = () => {
  return (
    <g>
      <path d="M15.994 2.643 16 2.75v10.494a.75.75 0 0 1-1.121.652l-.09-.06L11 10.892V12.8a.7.7 0 0 1-.7.7H.7a.7.7 0 0 1-.7-.7V3.2a.7.7 0 0 1 .7-.7h9.6a.7.7 0 0 1 .7.7v1.904l3.79-2.946a.75.75 0 0 1 1.204.485zM9.5 4h-8v8h8V4zm5 .284L11 7.004V8.99l3.5 2.721V4.284z" />
    </g>
  );
};

export default withIcon(IconVideo);
